<template>
  <div>
    Logs
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'job-board-logs',
    computed: {
      ...mapState('logs', {
        jobBoard: state => state.currentJobBoard
      })
    }
  }
</script>
<style>
</style>
